<script>
import Repositories from '@/repositories';
const WorkOrderItemOrderItemRepository = Repositories.get(
  'workorderitemorderitems'
);
const OrderItemsRepository = Repositories.get('orderitems');
const WorkOrdersRepository = Repositories.get('workorders');
const WorkOrderItemsRepository = Repositories.get('workorderitems');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
import scrollMixin from '@/mixins/scrollWheelMixin';

export default {
  components: {
    Loading,
    Tooltip,
    Multiselect,
  },
  props: {
    orderItem: { type: Object },
    availableQuantity: { type: Number, default: 0 },
    quantityType: { type: String, default: 'unitary' },
  },
  mixins: [scrollMixin],
  data() {
    return {
      isLoading: false,
      workOrdersList: [],
      form: {
        workOrder: null,
        quantity: 0,
      },
      workOrderItem: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      WorkOrdersRepository.getAll()
        .then(({ data }) => {
          this.workOrdersList = data.data;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    changeOrdered(idPublic, requestInstead) {
      this.isLoading = true;
      WorkOrderItemOrderItemRepository.actions
        .cancelOrdered({ requestInstead: requestInstead }, idPublic)
        .then(() => {
          let foundIndex = this.orderItem.workOrderItemOrderItems.findIndex(
            (x) => x.idPublic == idPublic
          );

          if (foundIndex >= 0) {
            let { reservedQuantity, totalQuantity } =
              this.orderItem.workOrderItemOrderItems[foundIndex];

            this.$emit('order-item-updated', {
              ...this.orderItem,
              reservedQuantity:
                this.orderItem.reservedQuantity -
                (totalQuantity - reservedQuantity),
              workOrderItemOrderItems:
                this.orderItem.workOrderItemOrderItems.filter(
                  (x) => x.idPublic != idPublic
                ),
            });
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.$emit('reload-data');
        });
    },
    async submitForm() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        try {
          this.isLoading = true;

          let payload = {
            itemIdPublic: this.orderItem.itemIdPublic,
            workOrderIdPublic: this.form.workOrder.idPublic,
            quantity: this.form.quantity,
          };

          await OrderItemsRepository.actions.linkWithWorkOrder(
            payload,
            this.orderItem.idPublic
          );

          let { data } =
            await WorkOrderItemOrderItemRepository.customREST.getByOrderItem(
              this.orderItem.idPublic
            );

          let newReservedQuantity = data.reduce(function (prev, cur) {
            return prev + (cur.totalQuantity - cur.reservedQuantity);
          }, 0);

          this.$emit('order-item-updated', {
            ...this.orderItem,
            reservedQuantity: newReservedQuantity,
            workOrderItemOrderItems: data,
          });

          this.form = { workOrder: null, quantity: 0 };
          this.$v.form.$reset();
        } catch (error) {
          if (error.response && error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.$emit('reload-data');
        } finally {
          this.isLoading = false;
        }
      }
    },
    async selectionChanged(workOrder) {
      if (workOrder == null) return;

      try {
        this.isLoading = true;
        let { data } = await WorkOrderItemsRepository.getAll({
          itemIdPublic: this.orderItem.itemIdPublic,
          workOrderIdPublic: workOrder.idPublic,
        });

        if (data.data.length > 0) {
          this.workOrderItem = data.data.reduce(function (accumulator, item) {
            accumulator.totalQuantity =
              (accumulator.totalQuantity ?? 0) + (item.totalQuantity ?? 0);

            accumulator.reservedQuantity =
              (accumulator.reservedQuantity ?? 0) +
              (item.reservedQuantity ?? 0);

            accumulator.orderedQuantity =
              (accumulator.orderedQuantity ?? 0) + (item.orderedQuantity ?? 0);

            accumulator.consumedQuantity =
              (accumulator.consumedQuantity ?? 0) +
              (item.consumedQuantity ?? 0);

            return accumulator;
          }, {});
        } else {
          this.workOrderItem = null;
        }
      } catch (error) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }
    },
    wheelEditQuantity(event) {
      if (this.form.workOrder == null) {
        return;
      }

      this.form.quantity = this.scrollMixinEvent(
        event,
        this.form.quantity,
        0,
        this.availableQuantity
      );
    },
  },
  computed: {
    workOrderItemNotProcessed() {
      return (
        this.workOrderItem.totalQuantity -
        this.workOrderItem.consumedQuantity -
        this.workOrderItem.reservedQuantity -
        this.workOrderItem.orderedQuantity
      );
    },
    itemInOrderString() {
      if (this.workOrderItem == null) {
        return this.$t('orders.itemNotInOrder');
      }
      let newWorkOrderItemQuantity = this.workOrderItem.totalQuantity;
      let difference = this.form.quantity - this.workOrderItemNotProcessed;
      if (difference > 0) {
        newWorkOrderItemQuantity = `<span style="color: red">
        ${newWorkOrderItemQuantity + difference}
        </span>`;
      }

      return this.$t('orders.itemInWorkOrderInformation')
        .replace('$', newWorkOrderItemQuantity)
        .replace(
          '#',
          Math.max(0, this.workOrderItemNotProcessed - this.form.quantity)
        );
    },
  },
  validations() {
    return {
      form: {
        workOrder: {
          required,
        },
        quantity: {
          required,
          minValue: minValue(this.quantityType == 'unitary' ? 1 : 0.00001),
          maxValue: maxValue(this.availableQuantity),
        },
      },
    };
  },
};
</script>

<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <h4>Reservations</h4>

    <div class="flex-box">
      <b-form-group
        style="margin-bottom: 0"
        class="pr-3 flex-grow-1"
        :label="$t('workOrders.workOrder')"
      >
        <multiselect
          v-model="form.workOrder"
          :class="{
            'is-invalid': $v.form.workOrder.$error,
          }"
          :options="workOrdersList"
          :show-labels="false"
          :show-arrow="true"
          label="name"
          track-by="idPublic"
          @input="selectionChanged"
          :placeholder="$t('general.pickAValue')"
          ><template v-slot:noOptions>
            {{ $t('general.noResult') }}
          </template>
        </multiselect>

        <Tooltip :validations="$v.form.workOrder" />
      </b-form-group>

      <b-form-group
        class="pr-3"
        style="margin-bottom: 0"
        :label="`${$t('items.quantity')} (Max: ${this.availableQuantity})`"
      >
        <b-form-input
          :class="{
            'is-invalid': $v.form.quantity.$error,
          }"
          :disabled="form.workOrder == null"
          type="number"
          ref="quantityinput"
          :step="quantityType == 'unitary' ? '1' : '.00001'"
          v-model="form.quantity"
          :placeholder="$t('items.quantity')"
          @keydown.enter.prevent="submitForm"
          @wheel.prevent="wheelEditQuantity($event)"
        >
        </b-form-input>
        <Tooltip :validations="$v.form.quantity" />
      </b-form-group>

      <b-form-group style="margin-bottom: 0" class="align-bottom mt-auto">
        <b-button
          @click="submitForm"
          block
          style="height: 40px; margin-top: 27.5px"
          variant="primary"
          >{{ $t('general.add') }}
        </b-button>
      </b-form-group>
    </div>
    <small v-html="itemInOrderString"></small>

    <b-container class="p-0" fluid>
      <b-row class="custom-grid-header no-gutters">
        <b-col cols="8" class="custom-grid-header-column">
          {{ $t('workOrders.workOrder') }}
        </b-col>
        <b-col cols="3" class="custom-grid-header-column text-center">
          {{ $t('items.quantity') }}
        </b-col>
        <b-col cols="1" class="custom-grid-header-column text-center">
          {{ $t('general.action') }}
        </b-col>
      </b-row>

      <b-row
        v-for="workOrderItemOrderItem in orderItem.workOrderItemOrderItems"
        :key="workOrderItemOrderItem.idPublic"
        class="custom-grid-row no-gutters"
      >
        <b-col cols="8" class="custom-grid-row-column">
          {{ workOrderItemOrderItem.workOrderName }}
        </b-col>
        <b-col cols="3" class="custom-grid-row-column text-center">
          {{ workOrderItemOrderItem.totalQuantity }}
        </b-col>
        <b-col cols="1" class="custom-grid-row-column text-center">
          <b-dropdown
            dropleft
            class="card-drop"
            variant="link"
            toggle-class="text-decoration-none p-0"
            no-caret
          >
            <template #button-content>
              <i class="fas fa-ellipsis-h" />
            </template>
            <b-dropdown-item
              @click="changeOrdered(workOrderItemOrderItem.idPublic, true)"
            >
              <i class="fas fa-pen text-success mr-1"></i>
              {{ $t('items.requestInstead') }}
            </b-dropdown-item>

            <b-dropdown-item
              @click="changeOrdered(workOrderItemOrderItem.idPublic, false)"
            >
              <i class="fas fa-trash-alt text-danger mr-1"></i>
              {{ $t('items.cancelReservation') }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-row
        v-if="orderItem.workOrderItemOrderItems.length == 0"
        class="custom-grid-row no-gutters"
      >
        <b-col cols="12" class="custom-grid-row-column text-center">
          {{ $t('workOrders.noReservation') }}
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>